import isNil from 'lodash/isNil';
import { useEffect } from 'react';
import { useDependencies } from './useDependencies';
import { useSelector } from 'react-redux';
import { selectOpenAiDescriptionForRule } from '../../../../reducers/documentation/documentationReducer';
import { SWEEP_ELEMENTS } from '../helpers';
import { ConfigurationType } from '../types';
import { ConfigurationItem } from '../DependenciesTypes';

export const useInitializeOpenAiDescriptionForRule = ({
  configurationItem,
  crmOrgId,
  type,
}: {
  configurationItem: ConfigurationItem;
  crmOrgId: string;
  type: ConfigurationType;
}) => {
  const { getOpenAiDescriptionForRule } = useDependencies(crmOrgId);
  const { id, name, objectApiNames, objectName, filename, parentType } = configurationItem ?? {};
  const openAiDescription = useSelector(selectOpenAiDescriptionForRule(id, crmOrgId));
  const isSweepElement = SWEEP_ELEMENTS.includes(type);
  const firstObjectApiName = objectName ?? objectApiNames?.[0];

  useEffect(() => {
    const isNotFieldType = type && type !== ConfigurationType.fields;
    const isNotObjectType = type && type !== ConfigurationType.objects;
    const isOthers = !Object.values(ConfigurationType).includes(parentType as ConfigurationType);
    const isValidStateForOthers = isOthers && filename && id; //will be unified with SWEEP-7402

    if (
      !openAiDescription &&
      ((id &&
        name &&
        type &&
        !isNil(firstObjectApiName) &&
        isNotObjectType &&
        isNotFieldType &&
        !isSweepElement) ||
        isValidStateForOthers)
    ) {
      getOpenAiDescriptionForRule({
        objectName: firstObjectApiName ?? '',
        ruleName: name,
        ruleType: type,
        ruleId: id,
        crmOrgId,
        filename: filename ?? '',
      });
    }
  }, [
    crmOrgId,
    openAiDescription,
    getOpenAiDescriptionForRule,
    name,
    firstObjectApiName,
    type,
    id,
    isSweepElement,
    filename,
    parentType,
  ]);
};
